// File: src/pages/AdminEditorPage.jsx
import React, { useState, useRef } from 'react'
import PageBuilder from '../components/PageBuilder'
import { toast } from 'react-toastify'

export default function AdminEditorPage() {
  const [pageId, setPageId] = useState('adani-solar')
  const builderRef = useRef(null)

  const handleSave = async () => {
    if (!builderRef.current) return
    const res = await builderRef.current.savePage()
    if (res) {
    //   alert('Page saved successfully!')
    } else {
              toast.error(`Save failed`)
      
    }
  }

  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: 8, borderBottom: '1px solid #eee' }}>
        <input
          value={pageId}
          onChange={e => setPageId(e.target.value)}
          style={{ padding: 8 }}
        />
        <button onClick={() => window.location.reload()}>Reload Editor</button>
        <button
          onClick={handleSave}
          style={{ backgroundColor: '#2d9cdb', color: 'white', padding: '8px 16px', borderRadius: 4, border: 'none' }}
        >
          Save Page
        </button>
      </div>
      <div style={{ flex: 1 }}>
        <PageBuilder ref={builderRef} pageId={pageId} />
      </div>
    </div>
  )
}
